// extracted by mini-css-extract-plugin
export default {"component":"style_component__7X4Wy"};